<template>
  <CommonDrop
    v-model="currentValue"
    url="/trade/company/list"
    :disabled="disabled"
    :autoDefault="false"
    :filterable="true"
    :remote="true"
    size="mini"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "factory",
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {},
};
</script>
